import React from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';
// TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
// eslint-disable-next-line no-unused-vars
import Theme from 'Theme';
import { NoDataText, ActivityIndicator } from 'LocalGluons';
import AssetItem from './AssetItem';
// TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
// eslint-disable-next-line no-unused-vars
import defaultStyles from './AssetList.jss';

const noop = () => {};

// TODO: HACKING SOME SHIT HERE
const AssetList = ({
    style,
    items,
    isLoading,
    // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
    // eslint-disable-next-line no-unused-vars
    onSelectChannel,
    // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
    // eslint-disable-next-line no-unused-vars
    onSelectProgram
}) => {
    // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
    // eslint-disable-next-line no-unused-vars
    const renderItems = () =>
        items.map(({ data, modelType }) => {
            let title = '';
            let image = '';
            let description = '';

            if (modelType === 'vod') {
                title = data.titles[0].value;
                image = data.images[0].path;
                description = data.descriptions[0].value;
            } else if (modelType === 'tv') {
                title = data.name;
                // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
                // eslint-disable-next-line prefer-destructuring
                image = data.images[0];
                description = data.shortDescription;
            }

            return (
                <AssetItem
                    key={title}
                    onIconPress={() => {}}
                    onDescriptionPress={() => {}}
                    iconUrl={image}
                    title={title}
                    subTitle={description}
                />
            );
        });

    const renderNoDataText = () => (isLoading ? null : <NoDataText />);

    return (
        <View style={style}>
            {[
                items.length > 0 ? renderItems() : renderNoDataText(),
                isLoading ? (
                    <View style={{ marginTop: 5 }}>
                        <ActivityIndicator />
                    </View>
                ) : null
            ]}
        </View>
    );
};

AssetList.defaultProps = {
    style: {},
    items: [],
    isLoading: false,
    onSelectChannel: noop,
    onSelectProgram: noop
};

AssetList.propTypes = {
    style: PropTypes.shape({}),
    items: PropTypes.arrayOf(PropTypes.shape({})),
    isLoading: PropTypes.bool,
    onSelectChannel: PropTypes.func,
    onSelectProgram: PropTypes.func
};

export default AssetList;
